import React, { useState, useEffect } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  deleteAddress,
  getAddressList,
  setDefaultAddress,
} from "../redux/thunks/customerAddThunk";
import { Pencil, Trash } from "lucide-react";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../utils/urlCrypto";
const Addresslist = () => {
  const dispatch = useDispatch();
  const { customer_id: paramCustomerId } = useParams();
  const customer_id = decryptId(paramCustomerId);
  const { addressList } = useSelector((state) => state.customerAddress);
  const location = useLocation();
  const fromOrder = location.state?.from === "addOrder";

  const [selectedId, setSelectedId] = useState(1);
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (customer_id) {
      dispatch(getAddressList({ customer_id }))
        .unwrap()
        .then((res) => {
          // console.log("The res is ", res.data);

          const defaultAddress = res.data.find((addr) => addr.is_default);
          if (defaultAddress) {
            setSelectedId(defaultAddress.address_id);
          }
        });
    }
  }, [customer_id, dispatch]);

  const handleOndeleteAddress = (address_id) => {
    const payload = {
      address_id: address_id,
      is_confirmed: 1,
    };

    // console.log("Delete payload:", payload);

    dispatch(deleteAddress(payload))
      .unwrap()
      .then((res) => {
        if (!res.success) {
          toast.error(res.message || "Delete failed");
          return;
        }

        toast.success(res.message);
        // list refresh
        dispatch(getAddressList({ customer_id }));
      });
  };

  const handleOnselectDefaultAddress = (address_id) => {
    // alert("The btn clicked...");
    const payload = {
      address_id: address_id,
    };

    dispatch(setDefaultAddress(payload))
      .unwrap()
      .then((res) => {
        console.log("the res of selecting default address is :", res.data);
        if (!res.success) {
          toast.error(res.message);
          return;
        }

        toast.success(res.message);
        // navigate(`/customers-detail/${customer_id}`);
        navigate(-1);
      });
  };

  return (
    <section className="relative max-w-7xl mx-auto mt-4 min-h-screen  bg-slate-50">
      <DecorativeSquares /> 
      {/* Header */}
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center p-2 rounded-full hover:bg-gray-100"
        >
          <FaArrowLeft size={20} />
        </button>

        <h1 className="mx-auto text-xl font-semibold text-gray-900">
          Select Delivery Address
        </h1>
      </div>
      <div className="px-4 mt-8">
        <div className="mx-auto space-y-4 w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          {/* Address Items */}
          {addressList?.map((item) => (
            <label
              key={item.address_id}
              className={`
    flex gap-3 p-4 rounded-xl border transition-all duration-200
    ${
      selectedId === item.address_id
        ? "border-[#FF6943] bg-orange-50 cursor-not-allowed"
        : "border-gray-200 hover:border-[#FF6943] cursor-pointer"
    }
  `}
            >
              {/* Hidden Native Radio */}
              <input
                type="radio"
                checked={selectedId === item.address_id}
                disabled={selectedId === item.address_id} // 🔥 disables clicking again
                onChange={async () => {
                  if (selectedId === item.address_id) return;

                  setSelectedId(item.address_id);

                  if (fromOrder) {
                    try {
                      await handleOnselectDefaultAddress(item.address_id);
                      navigate("/add-new-order", {
                        state: {
                          selectedAddress: item,
                        },
                      });
                    } catch (err) {
                      console.error("Default update failed", err);
                    }
                  } else {
                    handleOnselectDefaultAddress(item.address_id);
                  }
                }}
                className="hidden"
              />

              {/* Custom Radio UI */}
              <div
                className={`
      mt-1 h-5 w-5 rounded-full border-2 flex items-center justify-center transition
      ${selectedId === item.address_id ? "border-[#FF6943]" : "border-gray-300"}
    `}
              >
                {selectedId === item.address_id && (
                  <div className="h-2.5 w-2.5 rounded-full bg-[#FF6943]" />
                )}
              </div>

              {/* Address Content */}
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <div className="flex items-center gap-2">
                    <h4 className="text-sm font-semibold text-gray-800">
                      {item.address_2}
                    </h4>
                    {item.is_default && (
                      <span className="text-[10px] px-2 py-0.5 rounded-full bg-orange-100 text-[#FF6943]">
                        Default
                      </span>
                    )}
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/edit-address/${encryptId(item.address_id)}`);
                      }}
                      className="p-2 border border-green-200 rounded-md hover:bg-green-100 transition"
                    >
                      <Pencil size={15} className="text-green-500" />
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        Swal.fire({
                          title: "Are you sure?",
                          text: "This address will be deleted!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonText: "Yes, delete it",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            handleOndeleteAddress(item.address_id);
                          }
                        });
                      }}
                      className="p-2 border border-red-200 rounded-md hover:bg-red-100 transition"
                    >
                      <Trash size={15} className="text-red-500" />
                    </button>
                  </div>
                </div>

                <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                  {item.address_1}
                </p>
              </div>
            </label>
          ))}

          {/* Add New Address */}
          <button
            onClick={() =>
              navigate(
                `/customer/add-customers-address/${encryptId(customer_id)}`,
              )
            }
            className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
          >
            <span className="text-lg">＋</span> Add New Address
          </button>
        </div>
      </div>
    </section>
  );
};

export default Addresslist;
